import type {PaymentMethod} from '@sollapay/enums';
import type {CreatedAtFilter} from '@sollapay/ui/components';

export type {CreatedAtFilter};

export const CREATED_AT_FILTER_VALUES: CreatedAtFilter[] = ['all', 'this_week', '7d', '30d', '90d'];

/** Sentinel for "no buyer assigned yet" in the buyer filter — not a real party id. */
export const UNASSIGNED_BUYER_FILTER_VALUE = '__unassigned';

export interface InstructionsFilterState {
  datePreset: CreatedAtFilter;
  amountMin?: number;
  amountMax?: number;
  purchaseIds: string[];
  buyerPartyIds: string[];
  paymentMethods: PaymentMethod[];
}

export const DEFAULT_INSTRUCTIONS_FILTER_STATE: InstructionsFilterState = {
  datePreset: 'all',
  purchaseIds: [],
  buyerPartyIds: [],
  paymentMethods: []
};
